import { api } from './index';

const BASE_PATH = '/api/internal/communes';

export type Commune = {
  name: string;
  regionId: number;
}

export const communesApi = {
  index(filter: string = ''): Promise<Array<Commune>> {
    return api({
      method: 'get',
      url: filter ? `${BASE_PATH}?filter=${filter}` : BASE_PATH,
    }).then(response => response.data.communes);
  },
};
